import { FC, PropsWithChildren } from "react";
import styled from "styled-components";
import { ThemedHeader } from "./ThemedHeader";
import { Footer } from "./Footer";
import { useConsistentClient } from "@/premium/hooks/consistentClient";

const Content = styled.div`
  //to push the footer down
  min-height: calc(100vh - 140px);
`;

export const ContentContainer: FC<PropsWithChildren<{}>> = ({ children }) => {
  useConsistentClient();

  return (
    <>
      <Content>
        <ThemedHeader />
        {children}
      </Content>
      <Footer />
    </>
  );
};
